<template>
  <div
    class="breadcrumbs flex flex-wrap hidden-mobile"
    itemscope
    itemtype="https://schema.org/BreadcrumbList"
  >
    <span
      v-if="backLinkActive"
      class="back-link w-100 flex mb10"
    >
      <router-link
        :to="backLinkUrl"
        class="fs14 lh17 ls0 no-transform no-underline flex middle-xs"
      >
        <i class="icon icon-chevron-left fs8 mr10" />
        <span>{{ backLinkText | htmlDecode }}</span>
      </router-link>
      <span class="divider hidden mx15 c-bg-primary center-self" />
    </span>
    <span
      v-for="(link, key) in paths"
      :key="link.route_link"
      class="breadcrumb-link flex mb10 middle-xs"
      itemprop="itemListElement"
      itemscope
      itemtype="https://schema.org/ListItem"
    >
      <router-link
        :to="link.route_link"
        class="no-transform no-underline fs14 lh17 ls0 c-body"
        itemprop="item"
      >
        <span itemprop="name">{{ link.name | htmlDecode }}</span>
      </router-link>
      <meta
        itemprop="position"
        :content="key + 1"
      >
      <i class="icon icon-chevron-right fs8 c-black mx10" />
    </span>
    <span
      itemprop="itemListElement"
      itemscope
      itemtype="https://schema.org/ListItem"
      class="current flex fs14 lh17 ls0 mb10 weight-700 center-self c-black semi-bold"
    >
      <span itemprop="name">{{ current | htmlDecode }}</span>
      <meta
        itemprop="position"
        :content="paths.length + 1"
      >
    </span>
  </div>
</template>

<script>
import { Breadcrumbs } from '@vue-storefront/core/modules/breadcrumbs/components/Breadcrumbs.ts'
import { localizedRoute, currentStoreView } from '@vue-storefront/core/lib/multistore'
import i18n from '@vue-storefront/i18n'

export default {
  mixins: [Breadcrumbs],
  props: {
    staticBackLinkActive: {
      type: Boolean,
      default: false,
      required: false
    },
    parentBackLinkActive: {
      type: Boolean,
      default: false,
      required: false
    },
    staticBackLinkText: {
      type: String,
      default: null,
      required: false
    },
    staticBackLinkUrl: {
      type: String,
      default: null,
      required: false
    },
    backLinkPreText: {
      type: String,
      default: null,
      required: false
    }
  },
  computed: {
    parentBackRoute () {
      return (this.paths.length > 0 && this.parentBackLinkActive) ? this.paths[this.paths.length - 1] : null
    },
    backLinkActive () {
      return this.staticBackLinkActive || this.parentBackRoute
    },
    backLinkText () {
      const preText = `${this.backLinkPreText ? `${this.backLinkPreText} ` : ''}`
      return `${preText}${this.parentBackRoute ? this.parentBackRoute.name : this.staticBackLinkText}`
    },
    backLinkUrl () {
      return this.parentBackRoute !== null ? this.parentBackRoute.route_link : this.staticBackLinkUrl
    },
    paths () {
      const routes = this.routes ? this.routes : this.getBreadcrumbsRoutes

      if (this.withHomepage) {
        return [
          { name: i18n.t('Home'), route_link: localizedRoute('/', currentStoreView().storeCode) },
          ...routes
        ]
      }

      return routes
    }
  }
}
</script>
<style scoped lang="scss">
@import '~theme/css/variables/grid';

.breadcrumbs {
  align-self: baseline;
}

.breadcrumb-link .icon {
  width: 5px;
  opacity: 0.5;
  margin-top: 2px;
}

.current {
  color: #949492;
}

@include desktop {
  .back-link,
  .breadcrumb-link,
  .current {
    margin-bottom: 0;
  }

  .back-link {
    width: auto;

    .icon {
      margin-right: 15px;
    }

    .divider {
      display: flex;
      width: 1px;
      height: 16px;
    }

    a {
      font-size: 16px;
      line-height: 19px;
    }
  }

  .breadcrumb-link .icon {
    margin-left: 15px;
    margin-right: 15px;
  }

  .back-link a,
  .breadcrumb-link a,
  .current {
    font-size: 16px;
    line-height: 19px;
  }
}
</style>
